var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"installers"}},[_c('h2',[_vm._v("Installer")]),_c('nav',{staticClass:"seeders"},[_c('button',{staticClass:"btn primary-box",on:{"click":_vm.doChanges}},[_vm._v("Update Database")])])])}
var staticRenderFns = []

export { render, staticRenderFns }